import React from "react";
import { FaRoute } from "react-icons/fa";

const PRESETS = [
  { hours: 1, label: "Última 1 h" },
  { hours: 12, label: "Últimas 12 h" },
  { hours: 24, label: "Últimas 24 h" },
];

function DashboardTracePanel({
  t,
  open,
  onToggle,
  onPresetHours,
  activePresetHours,
  traceLoading,
  traceError,
  machineCount,
  operatorCount,
  pointCount,
}) {
  return (
    <div className="map-trace-panel">
      <button
        type="button"
        className={`btn-search map-trace-toggle${open ? " active" : ""}`}
        onClick={onToggle}
        title={t("Rastros das máquinas e operadores")}
      >
        <FaRoute />
        <span className="map-trace-toggle-label">{t("Rastros")}</span>
      </button>

      {open && (
        <div className="map-trace-content">
          <p className="map-trace-intro">
            {t(
              "O mapa abre com o rastro da última hora. Máquina e operador ficam no último ponto conhecido, mesmo se a telemetria parou há dias."
            )}
          </p>

          <div className="map-trace-presets">
            {PRESETS.map((preset) => (
              <button
                key={preset.hours}
                type="button"
                className={
                  Number(activePresetHours) === preset.hours ? "is-active" : ""
                }
                onClick={() => onPresetHours(preset.hours)}
                disabled={traceLoading}
              >
                {t(preset.label)}
              </button>
            ))}
          </div>

          {traceLoading && (
            <p className="map-trace-stats">{t("Carregando...")}</p>
          )}

          {traceError && (
            <p className="map-trace-error" role="alert">
              {traceError}
            </p>
          )}

          {!traceLoading && machineCount > 0 && (
            <p className="map-trace-stats">
              {t("{{count}} máquinas", { count: machineCount })}
              {operatorCount
                ? ` · ${t("{{count}} operadores", { count: operatorCount })}`
                : ""}{" "}
              · {t("{{count}} pontos no mapa", { count: pointCount })}
            </p>
          )}
        </div>
      )}
    </div>
  );
}

export default DashboardTracePanel;
